import { useSnapshot } from 'valtio'

import cn from 'classnames'
import { type ReactElement } from 'react'
import { dataExportsProxy } from '../index/dataExportsProxy'
import Label from '../../../../shared/components/ui/forms/Label'
import Value from '../../../../shared/components/ui/forms/Value'
import { PlaceholderBox } from '../../../../shared/components/ui/PlaceholderBox'
import { ErrorBox } from '../../../../shared/components/ui/ErrorBox'
import { proxyGlobalAuth } from '../../../../shared/proxies/proxyGlobalAuth'
import DataExportStatusLabel from '../../../../shared/components/ui/DataExportStatusLabel'
import { GlobalDataExportStatus } from '../../../../shared/types/GlobalDataExportStatus'
import { JsonPropertyList } from '../../../../shared/components/ui/JsonPropertyList'

export function DataExportsData (): ReactElement {
  const snap = useSnapshot(dataExportsProxy)
  const userDataExportFiles = snap.currentUserDataExportFiles
  const { siteTheme: { buttonColors } } = useSnapshot(proxyGlobalAuth)

  const urlLinks = userDataExportFiles?.map((file, index) => (
    <a href={file.signedUrl} target="_blank" rel="noopener noreferrer" key={index}>
      <button className={cn(buttonColors.classes, 'rounded py-2 px-4 mx-2 text-white cursor-pointer')}>Download File {index === 0 ? '' : index + 1}</button>
    </a>
  ))
  return (
    <PlaceholderBox loading={snap.apiCall.loading} rows={40} rowHeight="h-5">
      <ErrorBox error={snap.apiCall.error}>
        <div className="grid grid-cols-2 border-b border-wpy-light-blue-700 my-8">
          <Label text="Status" />
          <Value>
            <div className="w-32">
              <DataExportStatusLabel status={snap.currentUserDataExport?.status || GlobalDataExportStatus.Pending} />
            </div>
          </Value>
          <Label text="Type" additionalClasses="border-l" />
          <Value>
            {snap.currentUserDataExport?.type}
          </Value>
          <Label text="Filters" additionalClasses="border-l" />
          <Value>
            <div className="flex">
              <JsonPropertyList jsonString={snap.currentUserDataExport?.filters} />
            </div>
          </Value>

        </div>
        <Value>

          {urlLinks}

        </Value>
      </ErrorBox>
    </PlaceholderBox>

  )
}
